import * as yup from 'yup';
import { isEmpty } from 'lodash';
import {
  FORM_KEYS, NO_OF_CHARS, SOURCE_OF_WEALTH_IDS, SOW_ESTIMATED_WEALTH_IDS, SOW_NET_INCOME_IDS,
} from 'shared/constant';

const { SOURCE_OF_WEALTH } = FORM_KEYS;

/**
 * Individual Field validation
 * @param {*} intl
 * @param {*} elementName
 */
export const sourceOfWealthScheme = (intl, elementName, estimatedWealth, netIncome) => {
  switch (elementName) {
    case SOURCE_OF_WEALTH.ESTIMATED_WEALTH:
      return yup.object().shape({
        [SOURCE_OF_WEALTH.ESTIMATED_WEALTH]: yup
          .string()
          .required(intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'sourceOfWealth.estimatedWealth' }) })),
      });
    case SOURCE_OF_WEALTH.WEALTH_FUNDS:
      return yup.object().shape({
        [SOURCE_OF_WEALTH.WEALTH_FUNDS]: yup
          .string()
          .required(intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'sourceOfWealth' }) })),
      });
    case SOURCE_OF_WEALTH.NET_INCOME:
      return yup.object().shape({
        [SOURCE_OF_WEALTH.NET_INCOME]: yup
          .string()
          .required(intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'sourceOfWealth.annIncome' }) })),
      });
    case SOURCE_OF_WEALTH.ESTIMATED_WEALTH_APPROX_VAL:
      return yup.object().shape({
        [SOURCE_OF_WEALTH.ESTIMATED_WEALTH_APPROX_VAL]: yup
          .string()
          .test(
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            (value) => {
              if ((estimatedWealth === SOW_ESTIMATED_WEALTH_IDS.BELOW_500K || estimatedWealth === SOW_ESTIMATED_WEALTH_IDS.ABOVE_10M) && !value) return false;
              return true;
            },
          ),
      });
    case SOURCE_OF_WEALTH.NET_INCOME_APPROX_VAL:
      return yup.object().shape({
        [SOURCE_OF_WEALTH.NET_INCOME_APPROX_VAL]: yup
          .string()
          .test(
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            (value) => {
              if ((netIncome === SOW_NET_INCOME_IDS.BELOW_50K || netIncome === SOW_NET_INCOME_IDS.ABOVE_1M) && !value) return false;
              return true;
            },
          ),
      });
    default:
      return null;
  }
};

export const otherSourceOfWealthSchema = (intl, elementName, sourceOfWealthValue) => {
  switch (elementName) {
    case SOURCE_OF_WEALTH.TOTAL_YRS_EXP:
      return yup.object().shape({
        [SOURCE_OF_WEALTH.TOTAL_YRS_EXP]: yup
          .string()
          .test(
            intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'sourceOfWealth.totalExp' }) }),
            intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'sourceOfWealth.totalExp' }) }),
            (value) => {
              if (sourceOfWealthValue === SOURCE_OF_WEALTH_IDS.SAL_PRO_INCOME_PENSION && !value) return false;
              return true;
            },
          ),
      });
    case SOURCE_OF_WEALTH.DETAIL_OF_REL:
      return yup.object().shape({
        [SOURCE_OF_WEALTH.DETAIL_OF_REL]: yup
          .string()
          .test(
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            (value) => {
              if (sourceOfWealthValue === SOURCE_OF_WEALTH_IDS.INHERITANCE && !value) return false;
              return true;
            },
          ),
      });
    case SOURCE_OF_WEALTH.YR_OR_INHERITANCE:
      return yup.object().shape({
        [SOURCE_OF_WEALTH.YR_OR_INHERITANCE]: yup
          .string()
          .test(
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            (value) => {
              if (sourceOfWealthValue === SOURCE_OF_WEALTH_IDS.INHERITANCE && !value) return false;
              return true;
            },
          ),
      });
    case SOURCE_OF_WEALTH.APPROX_VAL_OF_INHERITANCE:
      return yup.object().shape({
        [SOURCE_OF_WEALTH.APPROX_VAL_OF_INHERITANCE]: yup
          .string()
          .test(
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            (value) => {
              if (sourceOfWealthValue === SOURCE_OF_WEALTH_IDS.INHERITANCE && !value) return false;
              return true;
            },
          ),
      });
    case SOURCE_OF_WEALTH.TYPE_ASSET_MARKET:
      return yup.object().shape({
        [SOURCE_OF_WEALTH.TYPE_ASSET_MARKET]: yup
          .string()
          .test(
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            (value) => {
              if (sourceOfWealthValue === SOURCE_OF_WEALTH_IDS.INV_SAVINGS && !value) return false;
              return true;
            },
          ),
      });
    case SOURCE_OF_WEALTH.APPROX_VAL_INV_SAV:
      return yup.object().shape({
        [SOURCE_OF_WEALTH.APPROX_VAL_INV_SAV]: yup
          .string()
          .test(
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            (value) => {
              if (sourceOfWealthValue === SOURCE_OF_WEALTH_IDS.INV_SAVINGS && !value) return false;
              return true;
            },
          ),
      });
    case SOURCE_OF_WEALTH.DETAIL_OF_BIZ:
      return yup.object().shape({
        [SOURCE_OF_WEALTH.DETAIL_OF_BIZ]: yup
          .string()
          .test(
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            (value) => {
              if (sourceOfWealthValue === SOURCE_OF_WEALTH_IDS.TRADE_BIZ && !value) return false;
              return true;
            },
          ),
      });
    case SOURCE_OF_WEALTH.TYPE_OF_ACT:
      return yup.object().shape({
        [SOURCE_OF_WEALTH.TYPE_OF_ACT]: yup
          .string()
          .test(
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            (value) => {
              if (sourceOfWealthValue === SOURCE_OF_WEALTH_IDS.TRADE_BIZ && !value) return false;
              return true;
            },
          ),
      });
    case SOURCE_OF_WEALTH.APPROX_VAL_REV:
      return yup.object().shape({
        [SOURCE_OF_WEALTH.APPROX_VAL_REV]: yup
          .string()
          .test(
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            (value) => {
              if (sourceOfWealthValue === SOURCE_OF_WEALTH_IDS.TRADE_BIZ && !value) return false;
              return true;
            },
          ),
      });
    case SOURCE_OF_WEALTH.OTHER_SOURCE_OF_WEALTH:
      return yup.object().shape({
        [SOURCE_OF_WEALTH.OTHER_SOURCE_OF_WEALTH]: yup
          .string()
          .test(
            intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'sourceOfWealth.otherSourceOfWealth' }) }),
            intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'sourceOfWealth.otherSourceOfWealth' }) }),
            (value) => {
              if (sourceOfWealthValue === SOURCE_OF_WEALTH_IDS.OTHERS && !value) return false;
              return true;
            },
          )
          .min(NO_OF_CHARS.SMALLEST_MIN, intl.formatMessage({ id: 'validation.mustBeMinimum' }, { number: NO_OF_CHARS.SMALLEST_MIN }))
          .max(NO_OF_CHARS.SMALLEST_MAX, intl.formatMessage({ id: 'validation.mustBeMaximum' }, { number: NO_OF_CHARS.SMALLEST_MAX })),
      });
    default:
      return null;
  }
};

/**
 * This is for section/page validation (when user submits the form)
 * @param {*} intl
 * @param {*} srcOfWealthValue
 */
export const sourceOfWealthPageSchema = (intl, srcOfWealthValue, estimatedWealth, netIncome) => yup.object().shape({
  [SOURCE_OF_WEALTH.WEALTH_FUNDS]: yup
    .string()
    .required(intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'sourceOfWealth' }) })),
  [SOURCE_OF_WEALTH.ESTIMATED_WEALTH]: yup
    .string()
    .required(intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'sourceOfWealth.estimatedWealth' }) })),
  [SOURCE_OF_WEALTH.NET_INCOME]: yup
    .string()
    .required(intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'sourceOfWealth.annIncome' }) })),

  [SOURCE_OF_WEALTH.TOTAL_YRS_EXP]: yup
    .string()
    .test(
      intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'sourceOfWealth.totalExp' }) }),
      intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'sourceOfWealth.totalExp' }) }),
      (value) => {
        if (srcOfWealthValue === SOURCE_OF_WEALTH_IDS.SAL_PRO_INCOME_PENSION && !value) return false;
        return true;
      },
    ),
  [SOURCE_OF_WEALTH.DETAIL_OF_REL]: yup
    .string()
    .test(
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      (value) => {
        if (srcOfWealthValue === SOURCE_OF_WEALTH_IDS.INHERITANCE && !value) return false;
        return true;
      },
    ),
  [SOURCE_OF_WEALTH.YR_OR_INHERITANCE]: yup
    .string()
    .test(
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      (value) => {
        if (srcOfWealthValue === SOURCE_OF_WEALTH_IDS.INHERITANCE && !value) return false;
        return true;
      },
    ),
  [SOURCE_OF_WEALTH.APPROX_VAL_OF_INHERITANCE]: yup
    .string()
    .test(
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      (value) => {
        if (srcOfWealthValue === SOURCE_OF_WEALTH_IDS.INHERITANCE && !value) return false;
        return true;
      },
    ),
  [SOURCE_OF_WEALTH.TYPE_ASSET_MARKET]: yup
    .string()
    .test(
      intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'sourceOfWealth.typeAssetMarket' }) }),
      intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'sourceOfWealth.typeAssetMarket' }) }),
      (value) => {
        if (srcOfWealthValue === SOURCE_OF_WEALTH_IDS.INV_SAVINGS && !value) return false;
        return true;
      },
    ),
  [SOURCE_OF_WEALTH.APPROX_VAL_INV_SAV]: yup
    .string()
    .test(
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      (value) => {
        if (srcOfWealthValue === SOURCE_OF_WEALTH_IDS.INV_SAVINGS && !value) return false;
        return true;
      },
    ),
  [SOURCE_OF_WEALTH.DETAIL_OF_BIZ]: yup
    .string()
    .test(
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      (value) => {
        if (srcOfWealthValue === SOURCE_OF_WEALTH_IDS.TRADE_BIZ && !value) return false;
        return true;
      },
    ),
  [SOURCE_OF_WEALTH.TYPE_OF_ACT]: yup
    .string()
    .test(
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      (value) => {
        if (srcOfWealthValue === SOURCE_OF_WEALTH_IDS.TRADE_BIZ && !value) return false;
        return true;
      },
    ),
  [SOURCE_OF_WEALTH.APPROX_VAL_REV]: yup
    .string()
    .test(
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      (value) => {
        if (srcOfWealthValue === SOURCE_OF_WEALTH_IDS.TRADE_BIZ && !value) return false;
        return true;
      },
    ),
  [SOURCE_OF_WEALTH.OTHER_SOURCE_OF_WEALTH]: yup
    .string()
    .test(
      intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'sourceOfWealth.otherSourceOfWealth' }) }),
      intl.formatMessage({ id: 'validation.elementIsRequired' }, { element: intl.formatMessage({ id: 'sourceOfWealth.otherSourceOfWealth' }) }),
      (value) => {
        if (srcOfWealthValue === SOURCE_OF_WEALTH_IDS.OTHERS && !value) return false;
        return true;
      },
    ),
  [SOURCE_OF_WEALTH.ESTIMATED_WEALTH_APPROX_VAL]: yup
    .string()
    .test(
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      (value) => {
        if ((estimatedWealth === SOW_ESTIMATED_WEALTH_IDS.BELOW_500K || estimatedWealth === SOW_ESTIMATED_WEALTH_IDS.ABOVE_10M) && isEmpty(value)) return false;
        return true;
      },
    ),
  [SOURCE_OF_WEALTH.NET_INCOME_APPROX_VAL]: yup
    .string()
    .test(
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      (value) => {
        if ((netIncome === SOW_NET_INCOME_IDS.BELOW_50K || netIncome === SOW_NET_INCOME_IDS.ABOVE_1M) && isEmpty(value)) return false;
        return true;
      },
    ),
});

// export default sourceOfWealthScheme;
